import { track } from '@opallabs/quanta'
import { registerAction } from '../../Action'

const TOGGLE_PERSONAL_PANEL = 'TOGGLE_PERSONAL_PANEL'

const hasPanelUpdates = (state) =>
  Boolean(
    (state.ws_frames || {}).download || (state.ws_frames || {}).notification
  )

const trackOpening = (state, payload) => {
  const isOpen = payload

  if (isOpen) {
    const wasShortcutPressed = payload
      ? payload.toggleType === 'keyboard_shortcut'
      : false

    track('Personal Panel: Opens', {
      'Open Method': wasShortcutPressed ? 'Shortcut' : 'Avatar',
      'Panel Updates': hasPanelUpdates(state),
    })
  }
}

const reducer = (state = {}, action) => {
  trackOpening(state, action.payload)

  return {
    ...state,
    isPersonalPanelOpen: action.payload,
    lastUpdatedWorkflowItemId: null,
  }
}

const togglePersonalPanel = registerAction(TOGGLE_PERSONAL_PANEL, { reducer })

export default togglePersonalPanel
